export const PIN_COL_MIN = 1;
export const PIN_COL_MAX = 3;
export const PIN_ROW_MIN = 1;
export const PIN_ROW_MAX = 2;
export const PIN_ROW_HEIGHT = 220;

export function clampPinSpan(value, min, max, fallback) {
  const number = Number(value);
  if (!Number.isFinite(number)) return fallback;
  return Math.min(max, Math.max(min, Math.round(number)));
}

export function readPinLayout(pin, defaultColSpan = PIN_COL_MIN) {
  return {
    colSpan: clampPinSpan(pin?.col_span, PIN_COL_MIN, PIN_COL_MAX, defaultColSpan),
    rowSpan: clampPinSpan(pin?.row_span, PIN_ROW_MIN, PIN_ROW_MAX, PIN_ROW_MIN),
  };
}

export function pinGridSize(colSpan) {
  const span = clampPinSpan(colSpan, PIN_COL_MIN, PIN_COL_MAX, PIN_COL_MIN);
  return {
    xs: 12,
    sm: span > 1 ? 12 : 6,
    md: span === 1 ? 4 : span === 2 ? 8 : 12,
    lg: span * 4,
  };
}

export function chartHeightForRowSpan(rowSpan) {
  const span = clampPinSpan(rowSpan, PIN_ROW_MIN, PIN_ROW_MAX, PIN_ROW_MIN);
  return span * PIN_ROW_HEIGHT;
}

export function columnsForWidth(width) {
  if (width >= 1200) return PIN_COL_MAX;
  if (width >= 600) return 2;
  return PIN_COL_MIN;
}

export function nextPinSize({
  colSpan,
  rowSpan,
  deltaX,
  deltaY,
  columnWidth,
  rowHeight = PIN_ROW_HEIGHT,
  maxColumns = PIN_COL_MAX,
}) {
  const safeColumn = columnWidth > 0 ? columnWidth : 1;
  const safeRow = rowHeight > 0 ? rowHeight : PIN_ROW_HEIGHT;
  const colStep = Math.round(deltaX / safeColumn);
  const rowStep = Math.round(deltaY / safeRow);
  const columnLimit = clampPinSpan(maxColumns, PIN_COL_MIN, PIN_COL_MAX, PIN_COL_MAX);
  return {
    colSpan: clampPinSpan(colSpan + colStep, PIN_COL_MIN, columnLimit, colSpan),
    rowSpan: clampPinSpan(rowSpan + rowStep, PIN_ROW_MIN, PIN_ROW_MAX, rowSpan),
  };
}
